/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeFieldSets.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Field Set Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, March 06, 2019 - 02:58:19 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      03/06/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const FIELDSET_LIST_CONTAINER_LOADED = 'FIELDSET_LIST_CONTAINER_LOADED';
export const FIELDSET_LIST_CONTAINER_UNLOADED = 'FIELDSET_LIST_CONTAINER_UNLOADED';
export const FIELDSET_LIST_TABLE_LOADED = 'FIELDSET_LIST_TABLE_LOADED';
export const FIELDSET_LIST_TABLE_UNLOADED = 'FIELDSET_LIST_TABLE_UNLOADED';

export const FIELDSET_LIST_CHANGE_GROUP = 'FIELDSET_LIST_CHANGE_GROUP';
export const FIELDSET_SELECT_ROW = 'FIELDSET_SELECT_ROW';

export const FIELDSET_ADD = 'FIELDSET_ADD';
export const FIELDSET_EDIT = 'FIELDSET_EDIT';
export const FIELDSET_DELETE = 'FIELDSET_DELETE';
export const FIELDSET_OPEN_WARNING = 'FIELDSET_OPEN_WARNING';
export const FIELDSET_CLOSE_WARNING = 'FIELDSET_CLOSE_WARNING';
export const FIELDSET_DELETE_DISABLE = 'FIELDSET_DELETE_DISABLE';
export const FIELDSET_VIEW_CHILD_ITEMS = 'FIELDSET_VIEW_CHILD_ITEMS';

export const FIELDSET_EDIT_CONTAINER_LOADED = 'FIELDSET_EDIT_CONTAINER_LOADED';
export const FIELDSET_EDIT_CONTAINER_UNLOADED = 'FIELDSET_EDIT_CONTAINER_UNLOADED';
export const FIELDSET_EDIT_FORM_LOADED = 'FIELDSET_EDIT_FORM_LOADED';
export const FIELDSET_EDIT_FORM_UNLOADED = 'FIELDSET_EDIT_FORM_UNLOADED';

export const FIELDSET_SET_PATHTRAIL = 'FIELDSET_SET_PATHTRAIL';
export const FIELDSET_EDIT_DATA_LOAD = 'FIELDSET_EDIT_DATA_LOAD';

export const FIELDSET_EDIT_CONTAINER_SUBMIT = 'FIELDSET_EDIT_CONTAINER_SUBMIT';
export const FIELDSET_EDIT_CONTAINER_CANCEL = 'FIELDSET_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeFieldSets.js